import { size } from 'lodash';
import { useMemo } from 'react';
import { INSIGHTS_EMPTY_STATES_TYPES } from '../EmptyState/EmptyState';

const useEmptyStates = ({ insightList, insightsValues }) => {
  const areAllValuesZero = useMemo(
    () => Object.values(insightsValues?.data || []).every(value => value === 0),
    [insightsValues.data]
  );
  const areAllInsightsToggledOff = useMemo(
    () => (insightList.items || []).every(item => !item.active),
    [insightList.items]
  );

  const isEmptyState =
    size(insightList.items) === 0 ||
    size(insightsValues.data) === 0 ||
    areAllValuesZero ||
    areAllInsightsToggledOff;

  const emptyStateType = areAllValuesZero
    ? INSIGHTS_EMPTY_STATES_TYPES.NO_VALUES
    : INSIGHTS_EMPTY_STATES_TYPES.NO_INSIGHTS;

  return {
    isEmptyState,
    emptyStateType
  };
};

export default useEmptyStates;
